import { lazy } from 'react';
const ItemDispatchInq = lazy(() => import('./itemDispatchInq'));

const itemDispatchInqRoutes = [
  {
    path: '/itemDispatchInq',
    component: ItemDispatchInq
  }
];

export default itemDispatchInqRoutes;
